import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";

import { getPerformanceRatingTypes } from "common/services/performance-rating.service";
import { normalize } from "common/lib/normalize";

const SelectPerformanceRatingType = ({
  validation,
  index,
  label,
}: {
  validation: any;
  index: number;
  label?: string;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.performanceRatings?.[index]?.performanceRatingType &&
        validation.errors.performanceRatings?.[index]?.performanceRatingType
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.performanceRatings?.[index]
            ?.performanceRatingType &&
          validation.errors.performanceRatings?.[index]?.performanceRatingType
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        setLoading(true);
        const ratingTypes = await getCachedPerformanceRatingTypeOptions();
        if (mounted) setData(ratingTypes);
      } catch (err: any) {
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name || ""}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label
        htmlFor={`performanceRatings[${index}].performanceRatingType`}
        className="form-label"
      >
        {label ? label : "Performance Rating"}
      </Label>
      <Select
        name={`performanceRatings[${index}].performanceRatingType`}
        id={`performanceRatings[${index}].performanceRatingType`}
        value={
          validation.values.performanceRatings[index]?.performanceRatingType
            ?.value
            ? validation.values.performanceRatings[index]?.performanceRatingType
            : null
        }
        placeholder="Select rating"
        onChange={(value: any) => {
          validation.setFieldValue(
            `performanceRatings[${index}].performanceRatingType`,
            value
          );
          validation.setFieldError(
            `performanceRatings[${index}].performanceRatingType`,
            ""
          );
        }}
        options={options}
        onBlur={() =>
          validation.setFieldTouched(
            `performanceRatings[${index}].performanceRatingType`,
            true
          )
        }
        className={
          validation.touched.performanceRatings?.[index]
            ?.performanceRatingType &&
          validation.errors.performanceRatings?.[index]?.performanceRatingType
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>
        {validation.errors.performanceRatings?.[index]?.performanceRatingType
          ?.value || ""}
      </FormFeedback>
    </FormGroup>
  );
};

let cachedPerformanceRatingTypes: any[] | null = null;
let performanceRatingTypeOptionsRequest: Promise<any[]> | null = null;

const getCachedPerformanceRatingTypeOptions = async () => {
  if (cachedPerformanceRatingTypes) return cachedPerformanceRatingTypes;

  if (!performanceRatingTypeOptionsRequest) {
    performanceRatingTypeOptionsRequest = getPerformanceRatingTypes({}).then(
      (response: any) => {
        cachedPerformanceRatingTypes = normalize(response.data);
        return cachedPerformanceRatingTypes || [];
      }
    );
  }

  return performanceRatingTypeOptionsRequest;
};

export default SelectPerformanceRatingType;
